import { useMemo } from 'react';
import { ROLES } from 'utils/Constants';
import {
  hasInitialContent,
  isPremiumContent,
  getEmptyCheckFn,
} from 'utils/contentValidation';

const getStatus = (textForm, orderType, userRole, textType) => {
  const isPremium = isPremiumContent(textForm, orderType, userRole);

  const base = {
    isPremium,
    hasInitialTextContent: hasInitialContent(textForm, userRole),
  };

  if (userRole === ROLES.CLIENT) {
    return {
      ...base,
      isRevisionSent:
        textForm &&
        ((textForm.globalRevisionSent === true &&
          textForm.revisionDone === false) ||
          (textForm.revisionSent === true &&
            textForm.revisionDone === false &&
            textForm.validated === false)),
    };
  }

  if (userRole === ROLES.WRITER) {
    return {
      ...base,
      isNotTranslation:
        (isPremium && textType === 'NON_TRANSLATED') ||
        (!textForm && orderType === 'PREMIUM' && textType === 'NON_TRANSLATED'),
      isDelivered:
        textForm &&
        textForm.globalRevisionSent === false &&
        textForm.revisionSent === false &&
        textForm.revisionDone === false &&
        textForm.validated === false &&
        textForm.delivered === true,
      isRevisionDone:
        textForm &&
        ((textForm.globalRevisionSent === true &&
          textForm.revisionDone === true) ||
          (textForm.revisionSent === true &&
            textForm.revisionDone === true &&
            textForm.validated === false)),
      isRevisionSent:
        textForm &&
        ((textForm.globalRevisionSent === true &&
          textForm.revisionDone === false) ||
          (textForm.revisionSent === true &&
            textForm.revisionDone === false &&
            textForm.validated === false)),
      isDraft:
        textForm &&
        textForm.globalRevisionSent === false &&
        textForm.revisionSent === false &&
        textForm.revisionDone === false &&
        textForm.validated === false &&
        textForm.delivered === false,
    };
  }

  return base;
};

export const useTextStatus = (textForm, orderType, userRole, textType) => {
  const status = useMemo(
    () => getStatus(textForm, orderType, userRole, textType),
    [textForm, orderType, userRole, textType]
  );

  return {
    ...status,
    isEmpty: getEmptyCheckFn(userRole),
  };
};
